import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import ContentMap from './ContentMap';
import {
  useAllTopicMap,
  useRedactedTopicIds,
  useTopicsHasLoaded,
} from './useAllTopics';
import PageLayout from '../app/layout/PageLayout';
import { useAppDispatch } from '../app/redux/useAppSelector';
import {
  redirectOnForbiddenError,
  redirectOnNotFoundError,
} from '../utils/error/useErrorRedirectEffect';
import PageMeta from '../utils/PageMeta';
import useNavigate from '../utils/router/useNavigate';
import { parseSlug } from '../utils/router/useSlug';

interface BaseTopicSubtopicsViewProps {
  topicSlug: string;
}

const BaseTopicSubtopicsView = ({ topicSlug }: BaseTopicSubtopicsViewProps) => {
  const [topicId] = parseSlug(topicSlug);
  const redactedTopicIds = useRedactedTopicIds();
  const hasLoaded = useTopicsHasLoaded();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const allTopicMap = useAllTopicMap();
  const topic = allTopicMap[topicId];

  let error: 'notFound' | 'forbidden' | null = null;
  if (!topic && hasLoaded) {
    error = redactedTopicIds.has(topicId) ? 'forbidden' : 'notFound';
  }
  useEffect(() => {
    if (error === 'forbidden') {
      redirectOnForbiddenError({ noun: 'topic', dispatch, navigate });
    } else if (error === 'notFound') {
      redirectOnNotFoundError({ noun: 'topic', dispatch, navigate });
    }
  }, [error, dispatch, navigate]);

  if (!topic) return null;

  return (
    <PageLayout.Content noPaddingX noPaddingY>
      <PageMeta title={`${topic.name} - Slab`} />
      <ContentMap topicId={topic.id} />
    </PageLayout.Content>
  );
};

const TopicSubtopicsView = () => {
  const { topicSlug } = useParams<{ topicSlug: string }>();
  return topicSlug ? <BaseTopicSubtopicsView topicSlug={topicSlug} /> : null;
};

export default TopicSubtopicsView;
